import moment from 'moment'
import React, { useEffect, useState } from 'react'
import ReactDOM from 'react-dom'
import { Image, Label } from 'semantic-ui-react'
import close_modal from '../../../assets/svg/close_modal.svg'
import { ContentHeader } from '../../../components/Header/ContentHeader'
import { _NOTIFICATIONS } from '../../../constants/notifications'
import { IMenuItem } from '../../../types/menuItems'
import { IUserDetail } from '../../../types/user'
import { INotificationData } from '../types/notification'
import NotificationsSidebarItem from './NotificationSidebarItem'

interface StateProps {
  user: IUserDetail | null
  notifications: INotificationData[]
  activeMenuItem: IMenuItem
}

interface DispatchProps {
  updateNotification: (employee_id: number, notification_ids: number[]) => Promise<number[]>
  deleteNotification: (notification: INotificationData) => void
  setActiveMenuItem: (item: string, path: string) => void
}

type Props = StateProps & DispatchProps


const NotificationsSidebar = (props: Props): JSX.Element => {
  const { notifications, activeMenuItem, user, setActiveMenuItem, updateNotification, deleteNotification } = props

  const [isVisible, setIsVisible] = useState(true)
  const [isClosing, setIsClosing] = useState(false)
  const [data, setData] = useState<INotificationData[]>(notifications)

  useEffect(() => {
    const _data: INotificationData[] = []
    notifications.forEach(d => {
      _NOTIFICATIONS.forEach(t => {
        if (t.id == +d.type) {
          const descriptionParts = t.description.split('custom_name')
          const content = (
            <p style={{ fontSize: '12px', color: '#232C58', margin: '.1rem 0 0 0' }}>{
              +d.type === 5 && d.identifier.indexOf('forecast') > -1 ? descriptionParts[0].replace('expenditures', 'expenditure forecast') : descriptionParts[0]
            }<strong>{d.content}</strong>{descriptionParts[1]}</p>
          )
          _data.push({
            id: d.id,
            title: t.name,
            content: content,
            identifier: d.identifier,
            project_name: d.project_name,
            created_at: d.created_at,
            seen: d.seen,
            type: t.type
          })
        }
      })
    })
    setData(_data.sort((a, b) => moment(b.created_at).diff(moment(a.created_at))))
  }, [notifications])

  useEffect(() => {
    if (activeMenuItem.path === '/before-close-notification') {
      setIsClosing(true)
      setTimeout(() => {
        setIsVisible(false)
        setActiveMenuItem('', '/close-notification')
      }, 300)
    }
  }, [activeMenuItem, setActiveMenuItem])

  const handleClose = () => {
    setIsClosing(true)
    setTimeout(() => {
      setIsVisible(false)
      setActiveMenuItem('', '/close-notification')
    }, 300)
  }

  const handleMarkAllAsRead = () => {
    updateNotification(user ? +user.id : -1, notifications.filter(n => !n.seen).map(n => +n.id))
  }

  const renderInbox = () => {
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <p style={{ margin: 0, fontSize: '1.45rem', fontWeight: 'bold', color: '#172533' }}>Inbox</p>
          <Label color='red' style={{ marginLeft: '.5rem', borderRadius: '.5rem', padding: '.5rem' }}>{data.filter(d => !d.seen).length}</Label>
        </div>
        <div style={{ cursor: 'pointer', color: '#747678', fontSize: '1rem', fontWeight: 'bold' }} onClick={handleMarkAllAsRead}>
          Mark all as read
        </div>
      </div>
    )
  }

  const renderArchive = () => {
    return (
      <div style={{ display: 'flex', alignItems: 'center', marginTop: '2rem' }}>
        <p style={{ margin: 0, fontSize: '1.45rem', fontWeight: 'bold', color: '#172533' }}>Archive</p>
        <Label color='grey' style={{ marginLeft: '.5rem', borderRadius: '.5rem', padding: '.5rem' }}>{data.filter(d => d.seen).length}</Label>
      </div>
    )
  }

  if (!isVisible) {
    return <></>
  }

  return ReactDOM.createPortal(
    <div className={`notification-sidebar-panel${isClosing ? ' closing' : ''}`} style={{ height: '100vh', width: '45rem', background: '#FFFFFF', boxShadow: '-10px 0 25px -5px rgba(21,21,21,0.25)', position: 'fixed', left: '84px', top: 0, zIndex: 1000, borderTopLeftRadius: '12px' }}>
      <Image src={close_modal} onClick={handleClose} style={{ margin: '3% 0 0 95%', cursor: 'pointer' }} />
      <div style={{ marginLeft: '40px' }}>
        <ContentHeader title='Notifications' marginTop='2.5rem' />
      </div>
      <div style={{ padding: '24px 24px 24px 40px', height: 'calc(100% - 100px)', overflow: 'scroll', scrollbarWidth: 'thin' }}>
        {data.filter(d => !d.seen).length !== 0 && renderInbox()}
        {data.filter(d => !d.seen).length !== 0 &&
          <NotificationsSidebarItem
            notifications={data.filter(d => !d.seen)}
            type='inbox'
            user={user}
            updateNotification={updateNotification}
            deleteNotification={deleteNotification}
          />}
        {data.filter(d => d.seen).length !== 0 && renderArchive()}
        {data.filter(d => d.seen).length !== 0 &&
          <NotificationsSidebarItem
            notifications={data.filter(d => d.seen)}
            type='archive'
            user={user}
            updateNotification={updateNotification}
            deleteNotification={deleteNotification}
          />}
      </div>
    </div>,
    document.body
  )
}

export default NotificationsSidebar
